import axios from 'axios';
import {
  captureException,
  createAxiosInterceptor,
  DISTRIBUTED_TRACE_HEADER,
} from '@tracewayapp/react';
import { HOST_API } from 'src/config-global';

export const RENTALS_CUSTOMER_TOKEN_KEY = 'rentalsCustomerAccessToken';

// The customer portal keeps its own axios instance (and NO cookies) so a
// customer session never clobbers an org-user session in the same browser.
const rentalsCustomerAxios = axios.create({ baseURL: HOST_API, withCredentials: false });

rentalsCustomerAxios.interceptors.request.use(createAxiosInterceptor());

rentalsCustomerAxios.interceptors.response.use(
  (res) => res,
  (error) => {
    captureException(error, {
      distributedTraceId: error?.config?.headers?.[DISTRIBUTED_TRACE_HEADER] || undefined,
    });
    return Promise.reject(error);
  }
);

export function setRentalsCustomerSession(token: string | null) {
  if (token) {
    localStorage.setItem(RENTALS_CUSTOMER_TOKEN_KEY, token);
    rentalsCustomerAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(RENTALS_CUSTOMER_TOKEN_KEY);
    delete rentalsCustomerAxios.defaults.headers.common.Authorization;
  }
}

export function getRentalsCustomerToken(): string | null {
  return localStorage.getItem(RENTALS_CUSTOMER_TOKEN_KEY);
}

export const rentalsCustomerEndpoints = {
  login: '/rentals-customer/login',
  current: '/rentals-customer/current',
  rentalData: '/rentals-customer/rentalData',
  branding: '/rentals-customer/branding/:organizationId',
};

export default rentalsCustomerAxios;
